import { useTranslation } from 'react-i18next'

const useCommonTranslations = () => {
  const { t } = useTranslation()
  return {
    ADD_MORE_INFO: t('edit-index.add-more-info.button', 'Add More Information'),
    REMOVE_FIELD: t('edit-index.remove-field.button', 'Remove Field'),
    // Add other common translations here
  }
}

export default useCommonTranslations
